/*global VeloxGridAndFormController, VeloxWebView*/
var uuid = require("uuid") ;
var pkg = require("../../../package.json") ;

var resellerController = new VeloxGridAndFormController("reseller", {
    grid : {
        directory: "views/reseller",
        name: "resellerGrid",
        joinFetch : [
            { otherTable: "velox_user", thisField: "r_code", otherField: "uid", name: "user"},
            { otherTable: "diag_count", thisField: "r_code", otherField: "r_code", name: "counts"}
        ]
    },
    form : {
        directory: "views/reseller",
        name: "resellerForm",
        joinFetch : [
            { otherTable: "velox_user", thisField: "r_code", otherField: "uid", name: "user"}
        ]
    },
    // importer: {
    //     name: "resellerImporter",
    //     openInPopup: true,
    //     popup: {
    //         size: "large",
    //         title: ""
    //     }
    // }
});

resellerController.formController.checkBeforeDelete = function(record, callback){
    return callback(null, false) ;
} ;

/**
 * Delete the realm and user when delete a reseller
 * 
 * @param {object} record the record to delete
 * @param {*} callback 
 */
resellerController.formController.getRecordsToDelete = function(record, callback){
    var records = [];
    if(!record.r_code){ return callback("wrong data") ; }
    records.push({action : "remove", table: "reseller", record : record}) ;
    records.push({action : "remove", table: "velox_link_user_realm", record : {user_uid: record.r_code, realm_code: record.r_code}}) ;
    records.push({action : "remove", table: "velox_user", record : {uid: record.r_code}}) ;
    callback(null, records) ;
} ;

resellerController.formController.validations.push(function checkCodeUnique(validationData, callback){
    if(resellerController.formController.mode !== "create"){ return callback() ;}
    resellerController.formController.api.api.reseller.searchFirst({r_code: validationData.data.r_code}, function(err, existingReseller){
        if(err){ return callback(err) ;}
        if(existingReseller){
            return callback(VeloxWebView.tr("reseller.aResellerAlreadyExist")) ;
        }
        callback() ;
    }) ;
}) ;

resellerController.formController.validations.push(function checkEndDat(validationData, callback){

    var startDate = validationData.data.r_renew_date || validationData.data.r_create_date || new Date() ;
    if(moment(validationData.data.r_date_end).diff(moment(startDate), 'months', true)>13){
        return callback(VeloxWebView.tr("reseller.cantMoreThan13Months")) ;
    }

    callback() ;
}) ;

/**
 * Save realm and user when save reseller 
 * 
 * @param {object} viewData the data input by user
 * @param {object} dataBeforeModif the record before user modification
 * @param {*} callback 
 */
// resellerController.importerController.getRecordsToSave = 
resellerController.formController.getRecordsToSave = function(viewData, dataBeforeModif, callback){
    var records = [] ;

    viewData.r_lang = "fr-FR" ;
    if(this.mode === "create"){
        viewData.r_create_date = new Date() ;
        records.push({
            table: "reseller", action: "insert", record: viewData
        }) ;
        records.push({
            table: "velox_user", action: "insert", record: {
                uid: viewData.r_code, 
                login: viewData.r_code, 
                lang: viewData.r_lang, 
                email: viewData.user.email, 
                auth_type: "password", 
                disabled: false, 
                active: false,
                activation_token: uuid.v4(),
                name: viewData.r_name,
                profile_code: "RESELLER"
            }
        }) ;
        records.push({
            table: "velox_link_user_realm", action: "insert", record: {
                user_uid: viewData.r_code, 
                realm_code: viewData.do_code
            }
        }) ;
    } else {
        records.push({
            table: "reseller", action: "update", record: viewData
        }) ;
        records.push({
            table: "velox_user", action: "update", record: {
                uid: viewData.r_code, 
                email: viewData.user.email, 
            }
        }) ;
    }

    callback(null, records) ;
};

resellerController.gridController.onResendMailActive = 
resellerController.formController.onResendMailActive = function(ev){
    var reseller = ev.data.data ;
    var baseUrl = pkg.serverUrl ;

    if(process.env.MODE !== "production"){
        baseUrl = pkg.serverDev ;
        if(process.env.MODE === "test"){
            baseUrl = pkg.serverTest ;
        } else {
            if(process.env.DEVICE === "mobile"){
                baseUrl = pkg.serverDevMobile ;
            }
        }
    }
    VeloxWebView.longTask(function(done){
        VeloxWebView.getLangTr(reseller.r_lang, function(err, trLang){

            var message = trLang("login.activationMessage", {
                link: baseUrl+"/goto?u="+encodeURIComponent("/#activate$"+reseller.user.activation_token),
                link_download: baseUrl+"/goto?u="+encodeURIComponent("/#download")
            });
            if(reseller.r_old_customer){
                message = trLang("login.activationMessageOldCustomer", {
                    link: baseUrl+"/goto?u="+encodeURIComponent("/#activate$"+reseller.user.activation_token),
                    link_download: baseUrl+"/goto?u="+encodeURIComponent("/#download")
                });
            }
            message = '<div style="font-family: Arial; font-size: 11pt">'+message+'</div>' ;

            if(err){ return done(err) ; }
            this.api.api.transactionalChanges(
                [
                    {
                        table : "velox_mail",
                        record: {
                            uid: uuid.v4(),
                            realm_code: reseller.r_code,
                            server_uid: "noreply", 
                            from_addr: "hydratest@analyse-piscine.com", 
                            to_addr: reseller.user.email,
                            subject: trLang("login.activationSubject"),
                            text: message,
                            html: message,
                            status: "tosend",
                            schedule_type: "now",
                            // html_report: "guide"
                        }
                    }
                ], function(err){
                if(err){ return done(err) ;}
                VeloxWebView.info(VeloxWebView.tr("reseller.mailResent")) ;
                done() ;
            }.bind(this)) ;
        }.bind(this)) ;
    }.bind(this)) ;
} ;


resellerController.gridController.onSendMailDownload = 
resellerController.formController.onSendMailDownload = function(ev){
    var reseller = ev.data.data ;
    var baseUrl = pkg.serverUrl ;
    if(process.env.MODE !== "production"){
        baseUrl = pkg.serverDev ;
        if(process.env.MODE === "test"){
            baseUrl = pkg.serverTest ;
        } else {
            if(process.env.DEVICE === "mobile"){
                baseUrl = pkg.serverDevMobile ;
            }
        }
    }
    VeloxWebView.longTask(function(done){
        VeloxWebView.getLangTr(reseller.r_lang, function(err, trLang){
            if(err){ return done(err) ;}
            var message = trLang("login.downloadMessage", {
                link_download: baseUrl+"/#download"
            });
            this.api.api.transactionalChanges(
                [
                    {
                        table : "velox_mail",
                        record: {
                            uid: uuid.v4(),
                            realm_code: reseller.r_code,
                            server_uid: "noreply", 
                            from_addr: "hydratest@analyse-piscine.com", 
                            to_addr: reseller.user.email,
                            subject: trLang("login.downloadMessageSubject"),
                            text: message,
                            html: message,
                            status: "tosend",
                            schedule_type: "now",
                            // html_report: "guide"
                        }
                    }
                ], function(err){
                if(err){ return done(err) ;}
                VeloxWebView.info(VeloxWebView.tr("reseller.mailSent")) ;
                done() ;
            }.bind(this)) ;
        }.bind(this)) ;
    }.bind(this)) ;
} ;

module.exports = resellerController ;